import axios from "axios";
import { getAuthHeader, catchApi } from "../../utils";

export const v2_get_notifications = async (params = {}) => {
  const query = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ""))
  ).toString();
  const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/notifications?${query}`;
  return catchApi(axios.get(url, getAuthHeader()).then((res) => res.data));
};
